import { TextField } from "@mui/material"
import { useEffect, useState } from "react";
import { styles } from "../../../App.styles";
import { BlankLine } from "../../BlankLine/BlankLine";
import { IFormWatcherComponentProps } from "../../IFormComponentProps";
import { withLoading } from "../../withLoading";

interface IProps {
    one?: string;
    two?: string;
}

const AssignmentWatcher: React.FC<IFormWatcherComponentProps<IProps>> = ({url, onChange, value}) => {
    const [data, setData] = useState<IProps>(value);

    useEffect(() => {
        setData(value);
    }, [value]);

    useEffect(() => {
        onChange(url, data);
    }, [data]);

    return (
        <>
            <BlankLine text="I would like to stop my dog" />
            <TextField onChange={e => setData({ ...data, one: e.target.value })} value={data.one || ''} variant="standard" InputProps={{ style: styles.blanksField}} />
            <br/>
            <BlankLine text="I can prevent my dog practicing this behaviour by:" />
            <TextField 
                multiline
                minRows={1} 
                fullWidth
                onChange={e => setData({ ...data, two: e.target.value })} 
                value={data.two || ''}
                variant="standard"
                InputProps={{ style: styles.blanksField}} />
        </>
    )
}

export const Day2Assignment = withLoading(AssignmentWatcher);